<template>
  <div class="member-signup-container">
    <FormHeader></FormHeader>
    <MemberForm />
    <FormModal></FormModal>
  </div>
</template>

<script>
// cheat sheet to Vue
// https://www.vuemastery.com/pdf/Vue-Essentials-Cheat-Sheet.pdf
// docs - note we are using Options API style and Single File Components
// https://vuejs.org/guide/introduction.html#api-styles
import MemberForm from './components/MemberForm.vue'
import FormHeader from './components/FormSections/FormHeader.vue';
import FormModal from './components/FormSections/FormModal.vue';

export default {
  components: { 
    // components have to be imported and registered here to be used in the template
    MemberForm,
    FormHeader,
    FormModal,
  }, 
  // copy this part into your component if you need state or dictionary
  data: (instance) => {
    return {
      values: instance.store[instance.store.currentCulture].values,
      d: instance.store[instance.store.currentCulture].dictionary,
      culture: instance.store.currentCulture,
    }
  },
  // run when the app is created, see life-cycle, mounted() is gonna be the most common
  // https://vuejs.org/api/options-lifecycle.html 
  mounted() {
    if (process.env.NODE_ENV === "development") {
      const dStore = this.store;
      window.dumpStore = function() {
        console.log(JSON.parse(JSON.stringify(dStore)))
      }
    }

    // TODO - remove after test-period
    function processNode(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const regex = /###(.*?)\|(.*?)###/g;
        let match;
        let modifiedText = node.nodeValue;
        let hasChanges = false;

        while ((match = regex.exec(node.nodeValue)) !== null) {
            hasChanges = true;
            const replacementText = `<span class="clickable-text" data-id="${match[2]}">${match[1]}</span>`;
            modifiedText = modifiedText.replace(match[0], replacementText);
        }

        if (hasChanges) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = modifiedText;

            while (tempDiv.firstChild) {
                node.parentNode.insertBefore(tempDiv.firstChild, node);
            }
            node.parentNode.removeChild(node);
        }
      } else if (node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('clickable-text')) {
        Array.from(node.childNodes).forEach(processNode);
      }
    }

    function handleClick(event) {
      if (event.target.classList.contains('clickable-text')) {
        const id = event.target.dataset.id;
        const url = `/umbraco/#/translation/dictionary/edit/${id}`;
        window.open(url, '_blank');
      }
    }
    function runLoop() {
      setTimeout(() => {
        processNode(document.body);
        document.body.removeEventListener('click', handleClick);
        document.body.addEventListener('click', handleClick);  
        runLoop();
      }, 500);
    }
    // TODO - remove after test-period
    runLoop();
  },
  methods: { 
    // updates and emits culture so other components can switch
    changeCulture() {
      this.culture = this.culture == 'dk' ? 'en' : 'dk';
      this.store.currentCulture = this.culture;

      // emitters should only be used for broad scope messaging. We still prefer parent/child component messaging 
      // this.emitter is available on all components and supports .emit (emit event with attached object) .on (listen) and .off (unsubscribe)
      this.emitter.emit('culture-change', this.culture);
    },
    
  }
}
</script>
<style lang="postcss">
.member-signup-container {
  position: relative;
}
  .checkbox input:checked ~ .checkmark{
    border-color:var(--color-blue);
    &::after{
      border-right-color:var(--color-blue);
      border-bottom-color:var(--color-blue);
    }
  }

  .radio input:checked ~ .checkmark{
    border-color:var(--color-blue);
    &::after{
      background-color:var(--color-blue);
    }
  } 

  .dp__input::placeholder{    
    position:relative;    
  }

  input.dp__input:not([type="submit"]):not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="range"]){
    padding-left:30px;
  }
  
  .dp__input + div::after{    
      content: '';
      position: absolute;
      width: 24px;
      height: 24px;
      background-image: url('data:image/svg+xml,%3Csvg id=%27svg-arrow-down-small%27 width=%2716%27 height=%2710%27 viewBox=%270 0 16 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M15 1 L8 8 L1 1%27 stroke=%27%23000%27/%3E%3C/svg%3E');
      background-repeat: no-repeat;
      background-position: center center;
      top: 6px;
      right: 0;
      transition: all ease 0.2s;    
  }

  .dp__input.dp__input_focus + div::after{
    transform: rotate(180deg);
   
  }

  .dp__icon.dp__input_icons{
    padding:0;
    top:calc(50% - 7px);
    color:var(--color-darkblue);
  }
  .dp__outer_menu_wrap {
    width: 100%;
    left: 0 !important;
    
    .dp__month_year_wrap {
      font-family: var(--font-it-ex);

      button {
      text-transform: lowercase;
      color: #404040;
      }
    }
    .dp__calendar_header_item {
      font-family: var(--font-it-ex);
      font-weight: normal;
      color: #404040;
    }

    .dp__cell_inner {
      border-radius: 50%;
      font-family: var(--font-it-md);
      font-weight: 300;
      color: #404040;

      &.dp__today {
        border-color: #c4c4c4;
      }
      &.dp__cell_offset {
        color: #c4c4c4;
      }
    }
  }
  .dp__instance_calendar *:focus {
    outline: 2px solid black;
  }
  .clickable-text {
    cursor: pointer;
    text-decoration: underline;
    color: red;
  }

  .error-msg{
    font-family: var(--font-it-ex);
    color: red;
  }
</style>


